import axios, {
  AxiosInstance,
  AxiosError,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from "axios";

const getAuthToken = (): string | null => localStorage.getItem("authToken");

export const accessURL: AxiosInstance = axios.create({
  // baseURL: "http://syncai-backend.test/",
  baseURL: "https://www.syncai.ltd/api/syncai-crm",
  validateStatus: (status: number): boolean => status >= 200 && status < 500,
});

accessURL.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getAuthToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

accessURL.interceptors.response.use((response: AxiosResponse) => {
  if (response.status === 401) {
    window.location.href = "/administrator/login";
  }
  return response;
});

export default accessURL;
